<template>
    <v-app id="inspire" full-width>
        <span
            v-for="item in items"
            :key="item.userid"
        >
            <base-dues-tax-receipt-letter
                :item="item"
                :year="year"
            />
            <base-dues-tax-receipt-stub
                :item="item"
                :year="year"
            />
        </span>
    </v-app>
</template>

<script>

    import BaseDuesTaxReceiptStub from "@/Pages/InternalPages/Reports/BaseDuesTaxReceiptStub.vue";
    import BaseDuesTaxReceiptLetter from "@/Pages/InternalPages/Reports/BaseDuesTaxReceiptLetter.vue";

    export default {
        name: "BaseDuesTaxReceiptReportPrint",
        components: {BaseDuesTaxReceiptLetter, BaseDuesTaxReceiptStub},
        props: {
            'items': {          // The items to report on
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'year': {          // The year to report on
                required: false,
                default: function () {
                    return ''
                }
            },
        },
        data() {
            return {
                sample: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'user_last_name',   text: 'Last Name',      align: `start`,     sortable: false, filterable: false,   },
                    {value: 'user_first_name',  text: 'First Name',     align: `start`,     sortable: false, filterable: false,   },
                    {value: 'sum_dues_amount',  text: 'Amount',         align: `end`,       sortable: false, filterable: false,   },
                    {value: 'date_deposit',     text: 'Deposit Date',   align: ` d-none`,   sortable: false, filterable: true,  search: this?.filters?.date_deposit },
                    {value: 'user_id',          text: 'User ID',        align: ` d-none`,   sortable: false, filterable: true,  search: this?.filters?.user_id },

                ]
            },

        },
        methods: {
            example() {
                console.log("This is just a test")
            },
        },
    }
</script>

<style>
html,body, .v-application, .v-app, .font-change {
    font-size: 10pt;
    font-family: ABCFavorit, system-ui, sans-serif !important;
}

.pagebreak {
    page-break-after: always;
    min-height: 1px;
}
</style>
